import { gql } from 'react-apollo';

export default gql`
  query investorOffers($query: QueryInput!) {
    investorOffers(query: $query) {
      _id
      items {
        _id
        favorited
        requestedInformation
        readyToInvest
        offer {
          _id
          status
          visibility
          tombstoneImageUrl
          listingType
          investmentInstrument
          area
          sector
          headerType
          headerVideoId
          offerPresentationTitle
          offerPresentationUrl
          stripeAccountId
          stripeProductId
          enableOfferPresentation
          minimumInvestment
          targetRaise
          offerCurrency
          valueRange
          assetStatus
          sharesForSale
          primaryObjective
          netAcres
          county
          averageDailyProduction
          baseCurrency
          geographicMandate
          fundType
          domicileOption
          domicileOnshore
          domicileOnshoreFund_other
          domicileOffShore
          domicileOffShore_other
          systematicDiscretionaryOption
          investmentCoActExemptionOption
          investmentAdvisorType
          leverage
          fundStructure
          fundStrategyClassfication
          fundStrategyClassficationOne
          fundStrategyClassficationTwo
          fundStrategyClassficationThree
          aumfund
          fundCapacity
          trackRecordFund
          trackRecordFirm
          altOfferTitle
          issuerCompany {
            _id
            name
          }
        }
      }
      total
    }
  }
`;



// WEBPACK FOOTER //
// ./src/apollo/queries/investorOffers.js